@for (status of viol3status; track status) {
  <div>
    {{ status.dokumentnummer }}<br />
    {{ status.deliverySourceNumber }}
    <ul>
      <li>
        <i class="far" aria-hidden="true"
          [ngClass]="getStyle(status.statusProduktion).icon"
        [style.color]="getStyle(status.statusProduktion).color"></i>
        Produktionsdel
      </li>
      <li>
        <i class="far" aria-hidden="true"
          [ngClass]="getStyle(status.statusTransport).icon"
        [style.color]="getStyle(status.statusTransport).color"></i>
        Transportdel
      </li>
    </ul>
  </div>
}
@if (viol3status.length === 0) {
  <div>
    Saknas
  </div>
}
@if (viol3status.length !== 0) {
  <a [routerLink]="['/viol3/preview', arbetsorderid]"
    target="_blank">Se Violinformation
    <i class="far fa-sm fa-external-link p-r-half"></i>
  </a>
}